import { render } from "./SingleWalletTesting.vue?vue&type=template&id=37f95130&scoped=true"
import script from "./SingleWalletTesting.vue?vue&type=script&lang=js"
export * from "./SingleWalletTesting.vue?vue&type=script&lang=js"

import "./SingleWalletTesting.vue?vue&type=style&index=0&id=37f95130&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2517490718/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f95130"]])

export default __exports__